import axios from "axios";
import axiosRequest from "@/utils/axios-config";

export const getFetcher = async (url) => {
  const req = await axios.get(url);
  return req.data;
};

export const postFetcher = async (url, { arg }) => {
  const updatedArgs = {};

  for (let updatedArg of Object.keys(arg)) {
    updatedArgs[updatedArg] = arg[updatedArg];
  }
  const { data } = await axios.post(url, updatedArgs);
  return data;
};

export const getHeaderJson = async (handshake) => {
  const config = {
    method: "get",
    url: `/json/header`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const notifyMe = async (handshake, entity_id, userId) => {
  let config = {
    method: "get",
    url: `/mstore/notify-product/${userId}/${entity_id}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  console.log("config//////////", config);
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const notifyMeOnDrop = async (handshake, sku, email) => {
  let config = {
    method: "post",
    url: "/customer/special-price-subscription",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data: JSON.stringify({ sku, email }),
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const activeCart = async (handshake, order_id) => {
  let config = {
    method: "post",
    url: "/cart/active",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data: JSON.stringify({ order_id }),
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
